import { render } from "./SvgElementHighlight.vue?vue&type=template&id=2dfa090e&scoped=true"
import script from "./SvgElementHighlight.vue?vue&type=script&lang=js"
export * from "./SvgElementHighlight.vue?vue&type=script&lang=js"

import "./SvgElementHighlight.vue?vue&type=style&index=0&id=2dfa090e&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfa090e"]])

export default __exports__